module.exports = __webpack_public_path__ + "img/loading.080609b0.gif";